import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import EmployerPartnershipsResourcesDetails from '../../subdepartmentdetails/EmployerPartnershipsResources'


function EmployerPartnershipsResources() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Employer Partnerships and Workforce Resources || Employment and Workforce Development";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Employment Workforce"
            title="Employer Partnerships Resources"
            subtitledown="Department of Employment & Workforce Development"
           />
            <EmployerPartnershipsResourcesDetails/>
        </div>
    </>
  )
}

export default EmployerPartnershipsResources